module.exports = __webpack_public_path__ + "assets/21.jpg?2694abafaef4ab89dc89090e03b2620e";